@if (onlyIcons()) {
  @if (previewThumbnails().length) {
    <div class="btn-group btn-icon">
      <button type="button" class="btn" [title]="'Bilder anzeigen' | mrTranslate" (click)="openImages()">
        <cds-icon shape="image-gallery" />
      </button>
    </div>
  }

  @if (!disabled() && previewThumbnails().length < maxAmount()) {
    <div class="btn-group btn-icon">
      <button type="button" class="btn" [title]="'Bild auswählen' | mrTranslate" (click)="fileInput.click()">
        <cds-icon shape="upload-cloud" />
      </button>
      @if (showCamera()) {
        <button
          type="button"
          class="btn"
          [title]="'Kamera öffnen' | mrTranslate"
          (click)="isWindows ? openCameraModal.set(true) : cameraInput.click()">
          <cds-icon shape="camera" />
        </button>
      }
    </div>
  }
} @else {
  @if (showLabel()) {
    <div class="clr-form-control clr-row nxm">
      <span class="clr-control-label">{{ title() | mrTranslate }}</span>
    </div>
  }

  <div class="clr-row nxm mh-100 mw-100-p">
    @if (!disabled() && previewThumbnails().length < maxAmount()) {
      @if (drag_drop()) {
        <div class="clr-row clr-col nxm" (uploadDropzone)="onFileChange($event)">
          <span for="fileInput" id="infoLabel" class="clr-col-12 clr-control-label">
            {{ 'Medien hochladen' | mrTranslate }} ({{ 'bis' | mrTranslate }} {{ maxSize() }}MB)
          </span>

          <div class="innerWrapper clr-row" [class.clr-justify-content-center]="!showCamera()">
            <cds-icon shape="upload-cloud" size="32" />
            @if (showCamera()) {
              <button
                type="button"
                class="btn clr-col-auto nxm"
                style="min-width: 43px"
                (click)="isWindows ? openCameraModal.set(true) : cameraInput.click()">
                <cds-icon shape="camera" />
              </button>
            }

            <span class="clr-col-12" style="font-size: smaller">{{ 'oder' | mrTranslate }}</span>
            <div class="clr-col-12 d-f center">
              <button type="button" class="nxm btn btn-sm btn-primary" type="button" (click)="fileInput.click()">
                {{ 'upload' | mrTranslate }}
              </button>
            </div>
          </div>
        </div>
      } @else {
        <div id="control-row" class="clr-row clr-col-auto nxm nxp margin-15-t">
          <div class="btn-group">
            <button
              type="button"
              class="btn"
              style="min-width: 43px"
              (click)="fileInput.click()"
              [title]="'Bild auswählen' | mrTranslate">
              <cds-icon shape="upload-cloud" />
            </button>
            @if (showCamera()) {
              <button
                type="button"
                class="btn"
                style="min-width: 43px"
                [title]="'Kamera öffnen' | mrTranslate"
                (click)="isWindows ? openCameraModal.set(true) : cameraInput.click()">
                <cds-icon shape="camera" />
              </button>
            }
          </div>
        </div>
      }
    }

    @if (previewThumbnails().length) {
      @if (drag_move()) {
        <div
          class="clr-row clr-col nxm previewThumbnailsContainer"
          [class.line]="galleryMode()"
          cdkDropList
          #dragList="cdkDropList"
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="previewThumbnails()"
          (cdkDropListDropped)="moveInArray($event)">
          @for (thumb of previewThumbnails(); track $index) {
            <div
              class="uploadImagePreviewContainer"
              [style.max-width]="thumb.plays ? '150px' : 'auto'"
              [class.highlight]="thumb.highlight"
              cdkDrag>
              <ng-container *ngTemplateOutlet="previewMedia; context: { $implicit: thumb, index: $index }" />
            </div>
          }
        </div>
      } @else {
        <div class="clr-row clr-col nxm previewThumbnailsContainer" [class.line]="galleryMode()">
          @for (thumb of previewThumbnails(); track $index) {
            <div
              class="uploadImagePreviewContainer"
              [style.max-width]="thumb.plays ? '150px' : 'auto'"
              [class.highlight]="thumb.highlight">
              <ng-container *ngTemplateOutlet="previewMedia; context: { $implicit: thumb, index: $index }" />
            </div>
          }
        </div>
      }
      <ng-template #previewMedia let-thumb let-i="index">
        @if (!disabled()) {
          <button type="button" class="deletePreview" [title]="'Löschen' | mrTranslate" (click)="deletePreview(i)">
            <cds-icon shape="times-circle" solid="true" />
          </button>
        }
        <a href="javascript:void(0);" (click)="openDoc(i)" style="margin: 0 auto">
          <img
            #preview
            [src]="thumb.src"
            alt=""
            class="uploadImagePreview"
            [class.invertWhenDark]="isSkizze()"
            draggable="false" />
        </a>
        @if (thumb.opens) {
          <!-- PDF Files -->
          <a href="javascript:void(0);" class="titleFile" (click)="openPdfDoc(i)">
            <br />
            {{ (thumb.file?.name | dotDotDot: 15) ?? ('Öffnen' | mrTranslate) }}
          </a>
        } @else if (thumb.plays) {
          <!-- Video Files -->
          <a
            href="javascript:void(0);"
            class="titleFile"
            (click)="
              (showPlay.checked = !showPlay.checked ? true : false) && openVideo(i);
              preview.style.display = showPlay.checked ? 'none' : 'block'
            ">
            <br />
            {{ (thumb.file.name | dotDotDot: 15) ?? ('Öffnen' | mrTranslate) }}
          </a>
          <input
            hidden
            type="checkbox"
            name="showPlay"
            id="showPlay"
            #showPlay
            ngModel
            [ngModelOptions]="{ standalone: true }" />

          @if (showPlay.checked) {
            @if (!thumb.url) {
              <clr-spinner [clrMedium]="true" />
            } @else {
              <video [src]="thumb.url" width="150" height="auto" autoplay [muted]="true" loop controls>
                Your Browser does not support HTML5 Video Playback
              </video>
            }
          }
        }
      </ng-template>
    }
  </div>
}

@if (imageMedia()) {
  <app-mediaviewmodal
    (onClose)="imageMedia.set(undefined)"
    [media]="imageMedia()"
    (deleteFoto)="deletePreview($event)" />
}

@if (isWindows && showCamera() && openCameraModal()) {
  <app-camera
    [(showWebcam)]="openCameraModal"
    [allowVideo]="allowCameraVideo()"
    (takenFoto)="onTakenFoto($event)"
    (takenVideo)="onTakenVideo($event)" />
}

<canvas #canvas hidden></canvas>
<video #video hidden></video>

<input type="file" #fileInput [accept]="acceptTypes()" hidden multiple (change)="onFileInputChange($event)" />

<input
  type="file"
  #cameraInput
  [accept]="acceptTypes()"
  hidden
  (change)="onFileInputChange($event)"
  capture="environment" />
